NtechApp.MobileGridNav = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._$tabs = null;
    this._$columns = null;

    this._$subtabs = null;
    this._$subcolumns = null;

    this._construct = function() {
        me._$view = $view;
        me._click = new NtechApp.TouchClickEvent();

        me._$tabs = me._$view.find("[data-mobileGridNavTab]");
        me._$columns = me._$view.find("[data-mobileGridNavTarget]");

        me._$subtabs = me._$view.find("[data-mobileGridSubnavTab]");
        me._$subcolumns = me._$view.find("[data-mobileGridSubnavTarget]");

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view.find(".dashboardMobileNav"), "[data-mobileGridNavTab]", function(event) {
            var $tab = $(event.target).closest("[data-mobileGridNavTab]");
            me._selectTab($tab);
        });

        me._click.listen(me._$view.find(".pageMobileNav"), "[data-mobileGridNavTab]", function(event) {
            var $tab = $(event.target).closest("[data-mobileGridNavTab]");
            me._selectTab($tab);
        });

        me._click.listen(me._$view.find(".pageMobileSubnav"), "[data-mobileGridSubnavTab]", function(event) {
            var $tab = $(event.target).closest("[data-mobileGridSubnavTab]");
            me._selectSubtab($tab);
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.MobileGridNav.EVENT_SELECT_TAB = "NtechApp.MobileGridNav.EventSelectTab";
NtechApp.MobileGridNav.EVENT_SELECT_SUBTAB = "NtechApp.MobileGridNav.EventSelectSubtab";

NtechApp.proto(NtechApp.MobileGridNav, {
    _selectTab: function($tab) {
        this._$tabs.removeClass("selected");
        $tab.addClass("selected");

        this._$columns.removeClass("selectedMobileCol");

        var col = $tab.attr("data-mobileGridNavTab");
        this._$view.find("[data-mobileGridNavTarget='" + col + "']").addClass("selectedMobileCol");

        $(window).trigger(NtechApp.MobileGridNav.EVENT_SELECT_TAB, [col]);
    },

    _selectSubtab: function($tab) {
        this._$subtabs.removeClass("selected");
        $tab.addClass("selected");

        this._$subcolumns.removeClass("selectedMobileSubcol");

        var col = $tab.attr("data-mobileGridSubnavTab");
        this._$view.find("[data-mobileGridSubnavTarget='" + col + "']").addClass("selectedMobileSubcol");

        $(window).trigger(NtechApp.MobileGridNav.EVENT_SELECT_SUBTAB, [col]);
    }
});